const BUNDLE_CONTAINER_SELECTOR = '.bundle-container'
const CHECKED_ACCESSORY_SELECTOR = '.checkbox-input.acc-checkbox:checked'
const ACCESSORY_ITEM_SELECTOR = '.acc-addon__item'
const ACCESSORY_SELECT_SELECTOR = '.acc-select'
const DOUBLE_QUANTITY_VARIANT_ID = '41867830460599'

type ProductFormLike = {
  closest(selector: string): Element | null
  querySelector(selector: string): HTMLInputElement | null
}

type QueryRootLike = {
  querySelector(selector: string): Element | null
}

const getMainProduct = (form: ProductFormLike) => {
  const idInput = form.querySelector('input[name="id"]')
  const quantityInput = form.querySelector('input[name="quantity"]')

  return {
    id: idInput?.value || '',
    quantity: quantityInput?.value || '1',
  }
}

const getAccessoryVariantId = (checkbox: Element): string => {
  const item = checkbox.closest(ACCESSORY_ITEM_SELECTOR) as HTMLElement | null
  if (!item) return ''

  return item.dataset.variant ||
    (item.querySelector(ACCESSORY_SELECT_SELECTOR) as HTMLSelectElement | null)
      ?.value ||
    ''
}

const getFreeItemIds = (form: ProductFormLike): string[] => {
  const wrapper = form.closest('.product-card-2-form')
  const value = wrapper?.getAttribute('data-freeitem') || ''

  return value
    .split(',')
    .map(id => id.trim())
    .filter(Boolean)
}

export const buildProductFormData = (
  source: FormData,
  form: ProductFormLike,
  root: QueryRootLike,
): FormData => {
  const result = new FormData()
  const items: Array<{ id: string; quantity: string | number }> = []
  const mainProduct = getMainProduct(form)
  const bundleContainer = root.querySelector(BUNDLE_CONTAINER_SELECTOR)

  if (form.closest('.product-form-wrap') && bundleContainer) {
    bundleContainer
      .querySelectorAll(CHECKED_ACCESSORY_SELECTOR)
      .forEach(checkbox => {
        const id = getAccessoryVariantId(checkbox)
        if (!id) return

        items.push({
          id,
          quantity:
            id === DOUBLE_QUANTITY_VARIANT_ID
              ? Number(mainProduct.quantity) * 2
              : mainProduct.quantity,
        })
      })
  }

  getFreeItemIds(form).forEach(id => items.push({ id, quantity: 1 }))

  if (items.length > 0 && mainProduct.id) {
    items.push(mainProduct)
    source.delete('id')
    source.delete('quantity')

    items.forEach((item, index) => {
      result.append(`items[${index}][id]`, item.id)
      result.append(`items[${index}][quantity]`, String(item.quantity))
    })
  }

  source.forEach((value, key) => result.append(key, value))
  return result
}
